module.exports = __webpack_public_path__ + "static/media/test.627bffe1.wav";